import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    ChipFieldWrapper: {
        border: `2px solid ${theme.palette.lightGrey.medium}`,
        borderRadius: 12,
        display: 'flex',
        justifyContent: 'space-between',
        overflow: 'hidden',
        '&:hover': {
            borderColor: `${theme.palette.typography.main}`,
            boxShadow: 'inset 0px 1px 4px rgba(0,0,0,0.06)',
            cursor: 'pointer',
        },
    },
    ChipField: {
        height: '3.3em',
        padding: '0 1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
    },
    ChipFieldAddButton: {
        borderRadius: '8px 0 0 8px',
        background: 'transparent',
        '& *': {
            color: theme.palette.typography.main,
        },
    },
    ChipFieldWrapperPlaceholder: {
        color: theme.palette.lightGrey.darker,
        fontWeight: 600,
    },
    ChipFieldWrapperError: {
        borderColor: theme.palette.red.main,
        '& .TTD-ChipFieldWrapper-placeholderError': {
            color: `${theme.palette.red.main} !important`,
        },
        '&:hover': {
            borderColor: theme.palette.red.main,
        },
    },
    ChipFieldDialogButtons: {},
    ChipFieldTextField: {
        width: '100%',
    },
}))
